import {request} from "@/utils/request";
import endpoint from "@/config/endpoint";

export default {
  postMobileVerification: async(payload) => {
    const {channel, ...restPayload} = payload;
    try {
      const res = await request.post(`${endpoint.SMS.OTP.ENROLLMENT.MOBILE_VERIFICATION.POST}?channel=${channel}`, restPayload);
      if (res) {
        return res.data;
      } else {
        throw res;
      }
    } catch (e) {
      return e;
    }
  },
  postMobileVerificationVerify: async(payload) => {
    try {
      const res = await request.post(`${endpoint.SMS.OTP.ENROLLMENT.MOBILE_VERIFICATION.VERIFY.POST}`, payload);
      if (res) {
        return res.data;
      } else {
        throw res;
      }
    } catch (e) {
      return e;
    }
  }
};
